import { useCallback, memo, useRef, useState, useEffect} from 'react';
import { useIndexTabPanelMain } from '../../../Context/IndexTabPanelMain';
import { useTabPanelItems } from '../../../Context/TabPanelItems';
import { TabPanel } from 'devextreme-react/tab-panel';
import { ContextMenu } from 'devextreme-react/context-menu'
import { Button } from 'devextreme-react/button';
import { BsTicket } from "react-icons/bs";
import UpfPopup from '../../../CardComponents/UpfPopup';
import WelcomeTab from './WelcomeTab';
import "./style.css"

const TabPanelMain = () => {
    const _toolbarRef = useRef(null)
    const _contextMenuRef = useRef(null)
    
    const {tabPanelItems, setTabPanelItems} = useTabPanelItems();
    const {indexTabPanelMain, setIndexTabPanelMain} = useIndexTabPanelMain();
    const closeButtonHandler = useCallback((item) => {
        const Handle = [...tabPanelItems];
        const index = Handle.indexOf(item);
    
        Handle.splice(index, 1);
        setTabPanelItems(Handle);

        if(tabPanelItems.length !== 0){
            setIndexTabPanelMain(tabPanelItems.length -2)
        }
      },[tabPanelItems])

    //estado e função do fecharAbasPopup
    const [clearTabRuleState, setClearTabRuleState] = useState()
    const [visibleFecharAbasPopup, setVisibleFecharAbasPopup] = useState(false)
    const [messageFecharAbasPopup, setMessageFecharAbasPopup] = useState("")

    //função para limpar abas
    const clearTabsFunction = (rule) => {
        setContextTarget(false)
        //fechar todas as tabs
        if(rule === "clearAllTabs"){
            setTabPanelItems([
            { ...tabPanelItems,
                icon: "home" 
                ,badge: ""
                ,component: <WelcomeTab/>
                ,text: Math.random()
            }
            ])
        }

        //fecha todas as abas a direita
        else if(rule === "clearTabsRight" && indexTabPanelMain < tabPanelItems.length - 1){
            setTabPanelItems(tabPanelItems.splice(0,indexTabPanelMain + 1))
            setIndexTabPanelMain(indexTabPanelMain)
        }

        //fecha todas as abas menos a atual
        else if(rule === "keepThisTab"){
            setTabPanelItems([
            { ...tabPanelItems,
                icon: "home" 
                ,badge: ""
                ,component: <WelcomeTab/>
                ,text: Math.random()
            },
            tabPanelItems[indexTabPanelMain]
            ])
            setIndexTabPanelMain(0)
            setIndexTabPanelMain(1)
        }
    }

    const hideFecharAbas = () => {
        setVisibleFecharAbasPopup(false)
    }
    //---------------------------

      const clearAllTabs = {
        text: "Fechar todas as abas"
        ,action: 'clearAllTabs'
        , icon: "clear"
        , onClick: () => {
            if (tabPanelItems.length > 1) {
                // setMessageFecharAbasPopup("Todas as abas serão fechadas! Deseja continuar?")
                // setVisibleFecharAbasPopup(true)
                clearTabsFunction("clearAllTabs")
            }
        }
    }

    const clearTabsRight = {
        text: "Fechar abas a direita"
        ,action: 'clearTabsRight'
        , icon: "clear"
        , onClick: () => {
            if (tabPanelItems.length > 1) {
                // setMessageFecharAbasPopup("Todas as abas a direita da atual serão fechadas! Deseja continuar?")
                // setVisibleFecharAbasPopup(true)
                clearTabsFunction("clearTabsRight")
            }
        }
    }

    const keepThisTab = {
        text: "Fechar outras abas"
        ,action: 'keepThisTab'
        , icon: "clear"
        , onClick: () => {
            if (tabPanelItems.length > 1) {
                // setMessageFecharAbasPopup("Todas as abas, com excessão da atual, serão fechadas! Deseja continuar?")
                // setVisibleFecharAbasPopup(true)
                clearTabsFunction("keepThisTab")
            }
        }
    }

    const contextMenuItems = [
        clearAllTabs,
        clearTabsRight,
        keepThisTab
    ];

    const cancelButtonFecharAbas = {
        text: "Cancelar"
        , icon: "close"
        , onClick: hideFecharAbas
    };

    const [contextTarget, setContextTarget] = useState(null);
    // const tabRefs = useRef([]);

    const handleContextMenu = (e, index) => {
        e.preventDefault();
        setIndexTabPanelMain(index);
        setContextTarget(e.target);
      };
    

    const titleTabPanel = useCallback((item) => {
        console.log(item)
        const closeHandler = () => {
            closeButtonHandler(item);
        }
        //o condicional está sendo feito pelo icone home, se outra tab 
        //usar deve ser alterado o condicional
        if(item.icon === "home") {
            return (
                <div className="tab-index">
                    {/* <BsTicket/>
                    <i
                        className={`dx-icon icon-tabtreeview dx-icon-${item.icon}`} 
                    /> */}
                    <span className="dx-icon icon-tabtreeview">
                        <BsTicket/>
                    </span>
                </div>
            )
        }
        else {
            return (
                <div className="tab-index" onContextMenu={(e) => handleContextMenu(e)} style={{ cursor: 'context-menu' }}>
                    <i
                        className={`dx-icon icon-tabtreeview dx-icon-${item.icon}`} 
                    />
                    <span className="span-text">
                        {item.title}
                    </span>
                        <i 
                            className="dx-icon  icon-close dx-icon-close" 
                            onClick={closeHandler}
                        />
                </div>
            )
        }
    },[closeButtonHandler])

    const contentTab = useCallback((sender) =>{
        return(
            <>
                {sender.component}
            </>
        )
    },[])
    const optionChange = useCallback((sender)=>{
        console.log(sender)
        console.log(indexTabPanelMain)
        if(sender.name === "selectedIndex"){
            setIndexTabPanelMain(sender.value)
        }
    }, [setIndexTabPanelMain])

    const hestiaOptions = {
        text: "Hestia"
        ,icon: "menu"
        ,hoverStateEnabled: true
      }

    // const openMenuContextFunction = (e) =>{
    //     console.log(e)
    //     // console.log("botao direito do mouse")
    // }

    
    
    return(
            <div className="tabpanel-main">
                <TabPanel
                    id="tabpanel-main"
                    items={tabPanelItems} 
                    deferRendering={false}
                    itemRender={contentTab}
                    selectedIndex={indexTabPanelMain}
                    onTitleRendered={(item) => {
                        setIndexTabPanelMain(tabPanelItems.length)
                    }
                    }
                    onSelectionChanged={(item) => {
                        setIndexTabPanelMain(tabPanelItems.indexOf(item.addedItems[0]))
                    }}
                    repaintChangesOnly={true}
                    animationEnabled={false}
                    showNavButtons={true}
                    scrollByContent={true}
                    itemTitleRender={(sender) => titleTabPanel(sender)}
                    onOptionChanged={optionChange}
                    // onItemContextMenu={
                    //         {
                    //             "text": "Fechar todas as abas",
                    //             "icon": "clear",
                    //             "onItemClick": ()=>{
                    //                 if(tabPanelItems.length > 1) {
                    //                   alert("Todas as abar serão fechadas! Deseja continuar?")
    
                    //                 //   setMessage("Todas as abar serão fechadas! Deseja continuar?")
                    //                 //   setVisible(true)
                    //                 }
                    //               }
                    //         } 
                    // }
                    // onTitleClick={openMenuContextFunction}
                />
                <ContextMenu
                    // cssClass='dx-overlay-content dx-popup-normal dx-popup-flex-height dx-resizable'
                    target={contextTarget}
                    items={contextMenuItems}
                    visible={contextTarget}
                    onHiding={() => setContextTarget(false)}
                    hideOnOutsideClick={true}
                    ref={_contextMenuRef}
                />
            </div>
    );
}

export default memo(TabPanelMain);